import { FormControlProps, FormControl as MuiFormControl } from "@mui/material";

type Props = FormControlProps;

export const FormControl = ({ children, ...props }: Props) => {
  return <MuiFormControl {...props}>{children}</MuiFormControl>;
};
